import { cn } from "@/lib/utils";

type SkeletonProps = {
    className?: string;
};

export function Skeleton({ className }: SkeletonProps) {
    return (
        <div
            aria-hidden
            className={cn(
                "animate-pulse rounded-lg bg-muted",
                className,
            )}
        />
    );
}

export function ProductCardSkeleton() {
    return (
        <div className="flex h-full flex-col overflow-hidden rounded-2xl border border-border/70 bg-card">
            <Skeleton className="aspect-square w-full rounded-none" />
            <div className="flex flex-1 flex-col gap-2 p-3">
                <Skeleton className="h-2.5 w-1/3" />
                <Skeleton className="h-4 w-full" />
                <Skeleton className="h-3 w-2/3" />
                <Skeleton className="h-3 w-1/2" />
                <Skeleton className="mt-2 h-9 w-full rounded-full" />
            </div>
        </div>
    );
}

export function CategoryTileSkeleton() {
    return (
        <div className="flex flex-col items-center rounded-2xl border border-border/60 bg-card p-3">
            <Skeleton className="mb-2 h-16 w-16 rounded-2xl" />
            <Skeleton className="h-3 w-16" />
            <Skeleton className="mt-1 h-2.5 w-20" />
        </div>
    );
}
